import emailjs from "emailjs-com";

export const sendEmail = async (data, tipo_form) => {
  try {
    const serviceID = process.env.REACT_APP_EMAILJS_SERVICE_ID || "";
    const templateID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID || "";
    const userID = process.env.REACT_APP_EMAILJS_USER_ID || "";

    if (!serviceID || !templateID || !userID) {
      throw new Error("Faltam configurações do EmailJS no .env");
    }

    // Adiciona o tipo_form aos dados enviados
    const emailData = {
      ...data,
      tipo_form, // Inclui o tipo do formulário na mensagem
    };

    const response = await emailjs.send(serviceID, templateID, emailData, userID);
    return response;
  } catch (error) {
    console.error("Erro ao enviar e-mail:", error);
    throw error;
  }
};